import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/orders';

const summary = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/total`, data);
};

const list = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/all`, data);
};

const listExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/all/export`, data, {
		responseType: 'blob',
	});
};

const detail = (merchantId, id, data) => {
	return Client.get(`${baseUrl}/${merchantId}/detail/${id}`, data);
};

const discounted = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/discounted`, data);
};

const voided = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/void`, data);
};

const refunded = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/refund`, data);
};

const cancelled = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/canceled`, data);
};

const cancelledDetail = (merchantId, id, data) => {
	return Client.get(`${baseUrl}/${merchantId}/canceled/${id}`, data);
};

const getVoidItem = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/voidByItem`, data);
};

const exportVoidItem = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/voidByItem/export`, data, {
		responseType: 'blob',
	});
};

const getTotalAmountVoidItem = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/voidByItem/totalAmount`, data);
};

const getGuestOrdersTotal = (merchantId, guestId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/guest/orders/total/${guestId}`,
		data
	);
};

const getGuestOrders = (merchantId, guestId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/guest/orders/${guestId}`, data);
};

const getSourceTypeList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/sourceTypes`, data);
};

export default {
	summary,
	list,
	listExport,
	detail,
	discounted,
	voided,
	refunded,
	cancelled,
	cancelledDetail,
	getVoidItem,
	exportVoidItem,
	getTotalAmountVoidItem,
	getGuestOrdersTotal,
	getGuestOrders,
	getSourceTypeList,
};
